import { render } from "./LiniView.vue?vue&type=template&id=9b87b4f0&ts=true"
import script from "./LiniView.vue?vue&type=script&lang=ts"
export * from "./LiniView.vue?vue&type=script&lang=ts"

import "./LiniView.vue?vue&type=style&index=0&id=9b87b4f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__